import {TrackingAPI} from 'api/tracking';
import {PillTag} from 'components/system/pilltag';
import {PillTagGroup} from 'components/system/pilltag_group';
import {ChevronRightIcon} from 'icons';
import Link from 'next/link';
import {difficultyLevelColors, difficultyLevelNames} from 'types/levels';
import styles from './question_link_list.module.css';

export const QuestionLinkList = ({questions, trackingComponent, trackingExtraData}: Props) => {
  return (
    <div className={styles.container}>
      {questions.map((question, ranking) => (
        <QuestionLink
          key={question.slug}
          ranking={ranking}
          trackingComponent={trackingComponent}
          trackingExtraData={trackingExtraData}
          {...question}
        />
      ))}
    </div>
  );
};

export const QuestionLink = ({
  uuid,
  slug,
  title,
  summary,
  tags,
  level,
  ranking,
  trackingComponent,
  trackingExtraData,
}: QuestionLinkProps) => {
  return (
    <Link prefetch={false} href={`/questions/${slug}`}>
      <a
        className={styles.link}
        onClick={() => {
          TrackingAPI.recommendedQuestionClicked({
            ranking,
            uuid,
            component: trackingComponent,
            extraData: trackingExtraData,
          });
        }}>
        <div className={styles.content}>
          <strong>{title}</strong>
          {summary && <p>{summary}</p>}
          <PillTagGroup>
            <PillTag color={difficultyLevelColors[level]}>{difficultyLevelNames[level]}</PillTag>
            {(tags || []).map((tag) => (
              <PillTag key={tag.id} color='greyLight'>
                {tag.name}
              </PillTag>
            ))}
          </PillTagGroup>
        </div>
        <ChevronRightIcon />
      </a>
    </Link>
  );
};

type Props = {
  questions: MinimalQuestion[];
  trackingComponent: string;
  trackingExtraData?: object;
};

type QuestionLinkProps = MinimalQuestion & {
  ranking: number;
  trackingComponent: string;
  trackingExtraData?: object;
};
